import { useEffect, useState } from "react";
import { MessageCircle, Phone, X, Plus } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { CONTACT, waLink } from "@/data/site";

export const FloatingButtons = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToContact = () =>
    document.getElementById("cotizador")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div
      data-testid="floating-buttons"
      className={`fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3 transition-all duration-300 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <div
        className={`flex flex-col items-end gap-3 transition-all duration-300 ${
          open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
        }`}
      >
        <FabItem
          testid="fab-quote"
          label={t.contact.quote}
          onClick={scrollToContact}
          className="bg-white text-black"
          icon={<Plus className="h-5 w-5" />}
        />
        <FabLink
          testid="fab-call"
          label={t.contact.call}
          href={`tel:+${CONTACT.phone1Raw}`}
          className="bg-brand text-white"
          icon={<Phone className="h-5 w-5" />}
        />
        <FabLink
          testid="fab-whatsapp"
          label="WhatsApp"
          href={waLink(t.contact.whatsappMsg)}
          className="bg-[#25D366] text-white"
          icon={<MessageCircle className="h-5 w-5" />}
        />
      </div>

      <button
        data-testid="fab-toggle"
        onClick={() => setOpen((o) => !o)}
        aria-label="Contact options"
        className="h-14 w-14 rounded-full bg-brand hover:bg-brand-hover text-white grid place-items-center shadow-2xl shadow-brand/30 transition-all hover:scale-105"
      >
        {open ? <X className="h-6 w-6" /> : <MessageCircle className="h-6 w-6" />}
      </button>
    </div>
  );
};

const FabLink = ({ testid, label, href, icon, className }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    className="group flex items-center gap-2"
  >
    <span className="rounded-full bg-black/80 backdrop-blur px-3 py-1.5 text-xs font-semibold text-white opacity-0 group-hover:opacity-100 transition-opacity">
      {label}
    </span>
    <span className={`h-12 w-12 rounded-full grid place-items-center shadow-lg transition-transform hover:scale-105 ${className}`}>
      {icon}
    </span>
  </a>
);

const FabItem = ({ testid, label, onClick, icon, className }) => (
  <button onClick={onClick} data-testid={testid} className="group flex items-center gap-2">
    <span className="rounded-full bg-black/80 backdrop-blur px-3 py-1.5 text-xs font-semibold text-white opacity-0 group-hover:opacity-100 transition-opacity">
      {label}
    </span>
    <span className={`h-12 w-12 rounded-full grid place-items-center shadow-lg transition-transform hover:scale-105 ${className}`}>
      {icon}
    </span>
  </button>
);
